<template>
	<div style="min-height: 220px;">

 		<v-tabs v-model="selected_tab" style="margin-top: -10px;">
        	<v-tab>Stats</v-tab>
        	<v-tab>Networks</v-tab>
<!--        	<v-tab>Inputs</v-tab>-->
        	<v-tab>Encoders</v-tab>
        	<v-tab>Outputs</v-tab>
      	</v-tabs>

		<div v-if="stats">

		<div v-if="dense">
			<div v-if="instance_type != 'headend'" class="stats-segment">
				<span class="font-weight-medium">Streamer: </span>
				<v-chip class="ml-2" text-color="white" small :color="streamer_status_color">{{streamer_status_text}}</v-chip>
			</div>

			<div class="mt-0" v-if="stats.system.load">
				<span class="font-weight-medium">Load: </span>
				<v-chip small>{{stats.system.load.avg1 | format_load}}</v-chip>
				<v-chip small>{{stats.system.load.avg5 | format_load}}</v-chip>
				<v-chip small>{{stats.system.load.avg15 | format_load}}</v-chip>
			</div>

<!-- CPU stats -->
			<div class="mt-0"  v-if="stats.system.cpu">
				<span class="font-weight-medium">CPUs: </span>
				<v-chip small>{{cpu_count}}</v-chip>
				<v-chip small :color="get_color(cpu_average)">Avg: {{cpu_average | format_cpu}}</v-chip>
				<v-chip small :color="get_color(cpu_max)">Max: {{cpu_max | format_cpu}}</v-chip>
			</div>

			<div class="mt-0"  v-if="stats.system.mem">
				<v-progress-linear height="21"  style="border-radius: 8px;" :value="get_mem_percent(stats.system.mem)" :color="get_mem_color(stats.system.mem)">
						<strong style="padding-left: 10px;">Mem: {{ get_mem_percent(stats.system.mem) | format_load }} %</strong>
					</v-progress-linear>
			</div>

			<div class="mt-0 mb-3" style="margin: 0 auto; text-align: left;" v-if="stats.system.disk">
				<span class="font-weight-medium mb-3">Disks: </span>
				<template class="my-1" v-for="(disk,name) in stats.system.disk">
					<v-chip small :color="get_disk_color(disk.used)">{{name}} {{disk.used}}%</v-chip>
				</template>
			</div>

		</div>


		<div v-if="!dense">

			<v-layout v-if="selected_tab == 0">
				<v-flex xs6>

			<div v-if="show_title_and_channel">
				<div style="font-size: 20px">{{title}}</div>
				<div class="mt-3" v-if="instance_type != 'headend'">
					<v-layout row>
						<v-flex xs3>
							<span class="font-weight-medium">Channel</span>
						</v-flex>
						<v-flex xs9>
							<v-chip class="" small @click.stop="open_channel">{{channel_title_for_instance}}</v-chip>
						</v-flex>
					</v-layout>
				</div>
			</div>
			<div v-if="instance_type != 'headend' && instance_type != 'mediamtx'" class="stats-segment">
				<v-layout row>
					<v-flex xs3><span class="font-weight-medium">Streamer</span></v-flex>
					<v-flex xs9><v-chip class="" text-color="white" small :color="streamer_status_color">{{streamer_status_text}}</v-chip></v-flex>
				</v-layout>
			</div>

 			<div v-if="update_status">
 				<v-layout row>
 					<v-flex xs3>
		 				<span class="font-weight-medium">Last update</span>
 					</v-flex>
 					<v-flex xs9>
		        		<v-chip class="" small :color="update_status_color" @click="show_update_status = !show_update_status">{{update_status.time}}</v-chip>
		        	</v-flex>
		        </v-layout>
        		<div v-if="show_update_status" style="background-color: #333; padding: 10px;" class="mt-2 mr-2">
            		<template v-for="msg in update_status.message">
            		<div class="caption">{{msg}}</div>
          			</template>
        		</div>
      		</div>

			<!-- Mobile streamer stats -->

			<div>

				<v-layout row>
					<v-flex xs3>
						<span class="font-weight-medium">System info</span>
					</v-flex>
					<v-flex xs9>

						<!-- Battery status -->
						<template v-if="stats.system.battery_percent">
							<v-chip small :color="get_battery_color(stats.system.battery_percent)" >
								<v-icon style="color: white;">{{get_battery_icon(stats.system.battery_percent)}}</v-icon>{{stats.system.battery_percent}}
							</v-chip>
						</template>

						<template v-if="stats.system.battery_state">
							<!-- Charging status -->
							<v-chip small :color="get_battery_state_color(stats.system.battery_state)">
								<v-icon style="color: white;" v-if="stats.system.battery_state == 'Charging'">power</v-icon>
								<v-icon style="color: white;" v-else-if="stats.system.battery_state == 'Full'">power</v-icon>
								<v-icon v-else style="color: white;">power_off</v-icon>
							</v-chip>
						</template>

						<template v-if="stats.system.temperature">

							<!-- Battery temperature status -->
							<v-chip small  :color="get_temp_color(stats.system.temperature)" style="color: white;">
								<v-icon>device_thermostat</v-icon>{{stats.system.temperature}}
							</v-chip>
						</template>
					</v-flex>
				</v-layout>
			</div>

			<!-- Other streamers -->

			<!-- IP field -->
			<div class="mt-2">
				<span class="font-weight-medium">IP: </span>
				<v-chip small> {{ get_field(instance, ['system_info', 'ip'], '') }} </v-chip>
			</div>

			<!-- Disk stats -->
			<div class="mt-1 mb-2 mr-2" style="margin: 0 auto; text-align: left;" v-if="stats.system.disk">
				<div class="font-weight-medium mb-1">Disks:</div>
				<div class="" v-for="(disk,name) in stats.system.disk" :key="name">
					<v-progress-linear class="mt-1 mb-1" height="19"  style="border-radius: 8px;" :value="disk.used" :color="get_disk_color(disk.used)">
						<v-layout row class="ml-2">
							<v-flex xs2>{{disk.used}} %</v-flex>
							<v-flex xs8>{{name}}</v-flex>
						</v-layout>
					</v-progress-linear>
				</div>
			</div>

			
		<!-- Decklink devices -->
<!--
		<div v-if="devices">
			<span class="font-weight-medium">Decklink devices:</span>
			<div v-for="device in devices">
				<v-chip small>{{device.id}}</v-chip> {{device.name}}
			</div>
		</div>-->

		</v-flex>

		<v-flex xs6>


			<!-- Load stats -->
			<div class="mt-2" v-if="stats.system.load">
				<v-layout row>
					<v-flex xs3><span class="font-weight-medium">Load:</span></v-flex>
					<v-flex xs9>
						<v-chip small>{{stats.system.load.avg1 | format_load}}</v-chip>
						<v-chip small>{{stats.system.load.avg5 | format_load}}</v-chip>
						<v-chip small>{{stats.system.load.avg15 | format_load}}</v-chip>
					</v-flex>
				</v-layout>
			</div>


			<!-- CPU stats -->
			<div class="mt-2"  v-if="stats.system.cpu">
				<span class="font-weight-medium">CPU:</span>
				<div>
					<span v-for="(cpu,num) in stats.system.cpu" :key="'cpu' + num">
						<v-chip small text-color="white" style="width: 50px;" :color="get_cpu_color(cpu)">{{get_cpu_used(cpu) | format_cpu}}</v-chip>
					</span>
				</div>
			</div>

			<!-- Memory stats -->
			<div class="mt-2"  v-if="stats.system.mem">
				<span class="font-weight-medium">Mem:</span>
				<div>
					<v-progress-linear class="mt-1 mb-1" height="19" style="border-radius: 8px;" :value="get_mem_percent(stats.system.mem)" :color="get_mem_color(stats.system.mem)">
						<span style="padding-left: 10px;">{{ get_mem_percent(stats.system.mem) | format_load }} %</span>
					</v-progress-linear>
				</div>
			</div>


		</v-flex>
	</v-layout>

	<!-- Networks tab -->
	<v-layout v-if="selected_tab == 1">
		<v-flex xs12>
			<div class="mt-2" v-if="stats.system.net">
				<div class="font-weight-medium">Network:</div>
				<v-layout row style="font-size: 12px;">
					<v-flex xs2>Device</v-flex>
					<v-flex xs2>IP</v-flex>
					<v-flex xs1>GW</v-flex>
					<v-flex xs2>Ping</v-flex>
					<v-flex xs2>Down</v-flex>
					<v-flex xs2>UP</v-flex>
					<v-flex xs1>Test status</v-flex>
				</v-layout>


				<template v-for="(info, device) in stats.system.net">
						<v-layout row v-if="device != 'lo'">
							<v-flex xs2>
								<v-chip small style="min-width: 95%;" :color="get_net_color(info, device)">
								<template v-if="info.type">
									<v-icon small style="margin-right: 5px;">{{get_net_icon(info, device)}}</v-icon>
								</template>
								{{device}}
							</v-chip>
							</v-flex>
							<v-flex xs2>
								{{info.ip}}
							</v-flex>

							<template v-if="streamer_net_stats && streamer_net_stats[device]">
								<v-flex xs1>
									<v-icon small v-if="streamer_net_stats[device].d_gw == true">check</v-icon>
									<template v-else>
										<v-btn small icon v-if="info.ip" style="width: 15px; height: 15px; margin: 0px; padding: 0px;" @click="set_default_interface(device)">
											<v-icon small>settings_ethernet</v-icon>
										</v-btn>
									</template>
								</v-flex>


								<v-flex xs2>
									<template v-if="streamer_net_stats[device].p">
										<v-icon small>network_ping</v-icon>{{streamer_net_stats[device].p}}
									</template>
								</v-flex>
								<v-flex xs2>
									<template v-if="streamer_net_stats[device].d_r">
										<v-icon small>download</v-icon>{{streamer_net_stats[device].d_r}}
									</template>
								</v-flex>
								<v-flex xs2>
									<template v-if="streamer_net_stats[device].u_r">
										<v-icon small>upload</v-icon>{{streamer_net_stats[device].u_r}}
									</template>
								</v-flex>
								<v-flex xs1>
									<v-icon small v-if="streamer_net_stats[device].t_q == true">hourglass_empty</v-icon>
									<v-icon small v-if="streamer_net_stats[device].t_i_p == true">sync</v-icon>
									<v-icon small v-if="streamer_net_stats[device].t_s == true">check</v-icon>
								</v-flex>

							</template>
						</v-layout>
						<template v-if="streamer_net_stats && streamer_net_stats[device]">
							<v-layout row v-if="streamer_net_stats[device].t_s == true && streamer_net_stats[device].t_r" style="background-color: rgba(0,0,0,0.3);">
								<v-flex xs3>
									{{streamer_net_stats[device].t_r.ts}}
								</v-flex>
								<v-flex xs2>
									{{streamer_net_stats[device].t_r.isp}}
								</v-flex>
								<v-flex xs2>
									<v-icon small>network_ping</v-icon>{{streamer_net_stats[device].t_r.l}}									
								</v-flex>
								<v-flex xs2>
									<v-icon small>download</v-icon>{{streamer_net_stats[device].t_r.dw}}									
								</v-flex>
								<v-flex xs2>
									<v-icon small>upload</v-icon>{{streamer_net_stats[device].t_r.up}}									
								</v-flex>
							</v-layout>
						</template>
				</template>
			</div>

		</v-flex>
	</v-layout>


	<!-- Inputs tab -->

<!--
	<v-layout v-if="selected_tab == 2">
		<v-flex xs12>
			{{input_routers_state}}
		</v-flex>
	</v-layout>
-->
	<!-- Outputs tab -->
	<v-layout v-if="selected_tab == 2">
		<v-flex xs12>
			<div class="mt-1 mb-3" style="margin: 0 auto; text-align: left;" v-if="encoders">
				<div class="font-weight-medium mb-1	">Encoders:</div>
				<v-layout row style="font-size: 12px;">
					<v-flex xs2>Enc</v-flex>
					<v-flex xs4>Name</v-flex>
					<v-flex xs2>Current</v-flex>
					<v-flex xs2>Config</v-flex>
					<v-flex xs2>Set</v-flex>
				</v-layout>

				<div class="my-1" v-for="enc in encoders">
					<v-layout row>
						<v-flex xs2>
							<v-chip style="font-size: 12px;" small>{{trim_encoder_type(enc.config.type)}}</v-chip>
						</v-flex>
						<v-flex xs4>
							{{enc.config.name}}
						</v-flex>
						<v-flex xs2>
							<v-chip style="font-size: 12px;" small>{{enc.state.bitrate}}</v-chip>
						</v-flex>
						<v-flex xs2>
							<v-chip style="font-size: 12px;" @click="set_bitrate(enc, get_encoder_config_bitrate(enc))" small>{{get_encoder_config_bitrate(enc)}}</v-chip>
						</v-flex>
						<v-flex xs1 style="text-align: right">
 							<v-edit-dialog lazy @save="set_bitrate(enc, bitrates[enc.config.name])">
								<v-icon small>settings</v-icon>
				                <template v-slot:input>
                  					<v-layout row>
                  						<v-text-field placeholder="Bitrate" v-model="bitrates[enc.config.name]"></v-text-field>
                      					<v-btn flat left color="green" @click.stop="set_bitrate(enc, bitrates[enc.config.name])">Save</v-btn>
                  					</v-layout>
               					</template>
              				</v-edit-dialog>
						</v-flex>

					</v-layout>
				</div>

			</div>
		</v-flex>

	</v-layout>


	<v-layout v-if="selected_tab == 3">
		<v-flex xs12>

			<div v-if="output_state">
				<v-layout row style="font-size: 12px">
					<v-flex xs1>Type</v-flex>
					<v-flex xs1>Adapter</v-flex>
					<v-flex xs1>Run</v-flex>
					<v-flex xs6>Qualities</v-flex>
				</v-layout>

				<v-layout row v-for="(data, uuid) in output_state.a">
					<v-flex xs1>{{data.type}}</v-flex>
					<v-flex xs1>{{data.adapter}}</v-flex>
					<v-flex xs1>Always</v-flex>
					<v-flex xs6>
						<v-chip small v-for="quality in data.qualities">{{quality}}</v-chip>
					</v-flex>
				</v-layout>

				<template v-for="(info, event_uuid) in output_state.e">
					<v-layout row v-for="(data,uuid) in info">
					<v-flex xs1>{{data.type}}</v-flex>
					<v-flex xs1>{{data.adapter}}</v-flex>
					<v-flex xs1>Event</v-flex>
					<v-flex xs4>
						<v-chip small v-for="quality in data.qualities">{{quality}}</v-chip>
					</v-flex>
					<v-flex xs5>
						{{event_uuid}}
					</v-flex>

					</v-layout>
				</template>

				<template v-for="(info, event_uuid) in output_state.eg">
					<v-layout row v-for="(data,uuid) in info">
					<v-flex xs1>{{data.type}}</v-flex>
					<v-flex xs1>{{data.adapter}}</v-flex>
					<v-flex xs1>EventGrp</v-flex>
					<v-flex xs4>
						<v-chip small v-for="quality in data.qualities">{{quality}}</v-chip>
					</v-flex>
					<v-flex xs5>
						{{event_uuid}}
					</v-flex>

					</v-layout>
				</template>

			</div>


			<div v-if="rtmp_state" class="mt-2 mb-3">
				<span class="font-weight-medium">RTMP stats:</span>
				<div class="quality-table">
					<div class="quality-table__header">
						<!-- <div v-for="header in rtmp_headers" :key="header.text" class="quality-table__header__value" :style="`width: ${header.width}`">{{header.text}}</div> -->
						<div v-for="header in quality_headers" :key="header.text" :style="`width: ${header.width}`">
							<v-tooltip top>
								<template slot="activator" slot-scope="{ on }" >
									<div v-on="on" class="quality-table__header__value">{{ header.text }}</div>
								</template>
								<span>{{ header.tooltip }}</span>
							</v-tooltip>
						</div>
					</div>

					<v-tooltip top v-for="row in rtmp_state" :key="row.url">
						<template slot="activator" slot-scope="{ on }" >
							<div v-on="on" class="quality-table__row" :class="[$dark() ? 'quality-table__row--dark' : 'quality-table__row--light']">
								<div v-for="header in quality_headers" :key="header.value" class="quality-table__value" :style="`width: ${header.width}; padding-top: 0px;`">
									<span small> {{ row[header.value] ? row[header.value].replace('kbits/s', '') : '-' }}</span>
								</div>
							</div>
						</template>
						<span>{{ row.url }}</span>
					</v-tooltip>

				</div>
			</div>

			<div v-if="srt_state" class="mt-2 mb-3">
				<span class="font-weight-medium">SRT stats:</span>
				<div class="quality-table">
					<div class="quality-table__header">
						<!-- <div v-for="header in srt_headers" :key="header.text" class="quality-table__header__value" :style="`width: ${header.width}`">{{header.text}}</div> -->
						<div v-for="header in quality_headers" :key="header.text" :style="`width: ${header.width}`">
							<v-tooltip top>
								<template slot="activator" slot-scope="{ on }" >
									<div v-on="on" class="quality-table__header__value">{{ header.text }}</div>
								</template>
								<span>{{ header.tooltip }}</span>
							</v-tooltip>
						</div>
					</div>

					<v-tooltip top v-for="row in srt_state" :key="row.url">
						<template slot="activator" slot-scope="{ on }" >
							<div v-on="on" class="quality-table__row" :class="[$dark() ? 'quality-table__row--dark' : 'quality-table__row--light']">
								<div v-for="header in quality_headers" :key="header.value" class="quality-table__value" :style="`width: ${header.width}; padding-top: 0px;`">
									<span small> {{ row[header.value] ? row[header.value].replace('kbits/s', '') : '-' }}</span>
								</div>
							</div>
						</template>
						<span>{{ row.url }}</span>
					</v-tooltip>

				</div>
			</div>

			<div v-if="srtla_state" class="mt-2 mb-3">
				<span class="font-weight-medium">SRTLA stats:</span>
				<div v-for="output in srtla_state" style="padding-left: 10px;">
					<div>{{output.quality}}:</div>
					<div style="display: grid; grid-template-columns: 200px 100px 100px 100px max-content; padding-left: 10px; font-size: 12px; color: lightgrey;">
						<div>Network</div>
						<div>Usage%</div>
						<div>Window</div>
						<div>In flight</div>
						<div>Priority</div>
					</div>


					<div v-for="(state, src) in output.data" style="display: grid; grid-template-columns: 200px 100px 100px 100px max-content; padding-left: 10px;">
						<div>{{state.device}} ({{state.src}})</div>
						<div>{{state.usage.toFixed(2)}}</div>
						<div>{{state.window}}</div>
						<div>{{state.in_flight}}</div>
						<div>
							<template v-if="state.priority == 0">Disabled</template>
							<template v-else>
								{{state.priority}}
							</template>
						</div>
					</div>
				</div>
			</div>


		</v-flex>
	</v-layout>


		</div>
		</div>

		<div v-if="!stats">
			No statistics available
		</div>


		<div class="mt-1 mb-3" style="margin: 0 auto; text-align: left;" v-if="!small && $is_privilege(['root', 'developer']) && is_broadcaster_process_info">
			<div class="font-weight-medium">Broadcaster processes:</div>
			<v-list dense>
				<v-list-tile>
					<v-list-tile-content style="width: 30%">Name</v-list-tile-content>
					<v-list-tile-content style="width: 50%">Info</v-list-tile-content>
					<v-list-tile-content style="width: 20%">Count</v-list-tile-content>
				</v-list-tile>
				<v-divider />
				<v-list-tile v-for="(count, name) in broadcaster_process_list" :key="name">
					<v-list-tile-content style="width: 30%">{{ name.split("|")[0] }}</v-list-tile-content>
					<v-list-tile-content style="width: 50%">{{ name.split("|")[1] }}</v-list-tile-content>
					<v-list-tile-content style="width: 20%">{{ count }}</v-list-tile-content>
				</v-list-tile>
				<v-list-tile>
					<v-list-tile-content style="width: 30%">Rest</v-list-tile-content>
					<v-list-tile-content style="width: 50%"></v-list-tile-content>
					<v-list-tile-content style="width: 20%">{{broadcaster_process.rest||0}}</v-list-tile-content>
				</v-list-tile>
				<v-divider></v-divider>
				<v-list-tile>
					<v-list-tile-content style="width: 30%">Unknown</v-list-tile-content>
					<v-list-tile-content style="width: 50%"></v-list-tile-content>
					<v-list-tile-content style="width: 20%">{{broadcaster_process.unknown||0}}</v-list-tile-content>
				</v-list-tile>
				<v-divider></v-divider>
				<v-list-tile :class="{'red--text': (broadcaster_process.total||0) > 32000, 'orange--text': (broadcaster_process.total||0) > 20000}">
					<v-list-tile-content style="width: 30%">Total</v-list-tile-content>
					<v-list-tile-content style="width: 50%"></v-list-tile-content>
					<v-list-tile-content style="width: 20%">{{broadcaster_process.total||0}}</v-list-tile-content>
				</v-list-tile>
			</v-list>
		</div>

		<div v-if="!small && selected_tab == 0 && instance_type == 'headend'">
			<span class="font-weight-medium">Listeners:</span>
			<headend :id="id"></headend>
		</div>

		<div v-if="!small && instance_type == 'mediamtx'">
			<span class="font-weight-medium">Streams:</span>
			<MediaMTX :id="id" :stats="instance_stats"></MediaMTX>
		</div>

	</div>
</template>

<script>
import InstanceModel from '@/models/instance.js';
import ChannelModel from '@/models/channel.js';
import Headend from './Headend'
import MediaMTX from './MediaMTX'

import datelib from '@/lib/date.js'


export default {
	props: ["id", "small", "dense", "show_title_and_channel", "on"],
	components: {
		Headend,
		MediaMTX
	},
	data() {
		var ch = this.$cloudserver.channel("instances:status:"+this.id);
		return {
			ws_channel: ch,
			show_update_status: false,
			bitrates: {},
			selected_tab: 0,
			quality_headers: [
				{
					text: 'Quality',
					value: 'quality',
					width: '30%',
					tooltip: 'Quality of stream'
				},
				{
					text: 'FPS',
					value: 'fps',
					width: '30%',
					tooltip: '1/s'
				},
				{
					text: 'Bitrate',
					value: 'bitrate',
					width: '40%',
					tooltip: 'kbits/s'
				},
				// {	text: 'frame', value: 'frame'},
				// {	text: 'time', value: 'time'},
				// {	text: 'url', value: 'url'},
			]
		}
	},
	filters: {
		format_load(load) {
			return load.toFixed(2);
		},
		format_cpu(cpu) {
			return cpu.toFixed(1);
		},
		format_version(version) {
			if (typeof(version) == "undefined") return "unknown"
			return version;
		}
	},
	created() {
	  this.ws_channel.join();
	},
	methods: {
		get_field(data, fields, default_value) {
			return _.get(data, fields, default_value);
		},
		open_channel () {
			var ch = InstanceModel.channel(this.instance);
			this.$router.push("/dashboard/channel/" + ch.uuid + "");
		},
		set_bitrate (enc, bitrate) {
			var self = this;
			var name = enc.config.name;
			InstanceModel.send_streamer(this.instance, {"type": "bitrate", "name": name, "bitrate": bitrate},(msg) => {
				self.$message.success("Streamer " + name + " bitrate changed to " + bitrate);
			}, (err) => {
				self.$message.error("Streamer " + name + " bitrate change failed");
			});
		},
		set_default_interface (ifname) {
			var self = this;
			InstanceModel.send_streamer(this.instance, {"type": "set_default_interface", "interface": ifname},(msg) => {
				self.$message.success("Default interface changed to " + ifname);
			}, (err) => {
				self.$message.error("Default interface change failed");
			});
		},
		trim_encoder_type (t) {
			var ret = t.replace("encoder.","")
/*			if (ret == "nvh265") return "h265";
			if (ret == "nvh264") return "h264";
			if (ret == "fdk_aac") return "aac";
			if (ret == "faac") return "aac";*/
			return ret;
		},
		get_encoder_config_bitrate (enc) {
			var config = enc.config;
			if (config["h264-bitrate"]) return config["h264-bitrate"];
			if (config["aac-bitrate"]) return config["aac-bitrate"];
			if (config["bitrate"]) return config["bitrate"];
			return "";
		},
		get_color (pr) {
			if (pr > 75) return "error";
			if (pr > 60) return "warning";
			return "success";
		},
		get_cpu_color(pr) {
			var val = this.get_cpu_used(pr);
			return this.get_color(val);
		},
		get_disk_color (pr) {
			if (pr > 90) return "error";
			if (pr > 80) return "warning";
			return "success";
		},
		get_mem_color (mem) {
			var val = this.get_mem_percent(mem);
			return this.get_color(val);
		},
		get_net_color (info, device) {
			if (!_.has(info, "ip") || info.ip == "nil") return "";
			if (device == "tun0") return "primary";
			return "success";
		},
		get_net_icon (info, device) {
			var t = info.type.toLowerCase();
			if (t == "wifi") return "wifi";
			if (t == "wired") return "settings_ethernet";
			if (t == "cellular") return "cell_tower"
			return "question_mark"
		},
		get_cpu_used(cpu) {
			return _.get(cpu, "used", cpu);
		},
		get_mem_percent (mem) {
			if(_.isObject(mem)) {
				var free = mem.free + mem.cached + mem.buffered;
				return 100 - (free / (mem.total / 100));
			}
			return mem;
		},
		get_battery_color (battery) {
			if (battery > 90) return "success";
			if (battery > 50) return "warning";
			return "error";
		},
		get_battery_state_color (state) {
			if (state == "Charging") return "success";
			if (state == "Full") return "success";
			return "warning";
		},
		get_battery_icon (battery) {
			if (battery == 100) return 'battery_full'
			if (battery > 90) return 'battery_6_bar';
			if (battery > 75) return 'battery_5_bar';
			if (battery > 40) return 'battery_4_bar';
			if (battery > 20) return 'battery_3_bar';
			return "battery_1_bar";
		},
		get_temp_color (temp) {
			if (temp == "Nominal") return "success";
			return "warning";
			if (temp < 30) return "success";
			if (temp < 40) return "warning";
			return "error";
		}
	},
	computed: {
		system_type() {
			return _.get(this.stats, "system.type");
		},
		cpu_count() {
			return Object.values(this.stats.system.cpu).length;
		},
		cpu_average() {
			var values = Object.values(this.stats.system.cpu);
			var ret = 0;
			_.each(values, (c) => {
				ret = ret + this.get_cpu_used(c);
			});
			ret = (ret / this.cpu_count);
			return ret;
		},
		cpu_max() {
			var values = Object.values(this.stats.system.cpu);
			var ret = _.maxBy(values, (c) => { return this.get_cpu_used(c); });
			return this.get_cpu_used(ret);
		},

		instance () {
			return InstanceModel.instance_by_id(this.id);
		},
		instance_type() {
			return _.get(this.instance, "type");
		},
		streamer_status () {
			var st = this.stats;
			if (typeof(st) != "undefined" && st.instance != null && typeof(st.instance) != "undefined") {
				return st.instance.streamer_state;
			}
			return false;
		},
		streamer_version () {
			var st = this.stats;
			if (typeof(st) != "undefined" && st.instance != null && typeof(st.instance) != "undefined") {
				if (typeof(st.instance.streamer_version) != "undefined" && st.instance.streamer_version != null) {
					return st.instance.streamer_version;
				}
			}
			return "";
		},
		streamer_status_text () {
			var ret = "Unknown";
			if(this.streamer_status == false) ret = "Not running";
			if(this.streamer_status) ret = "Running";
			return this.streamer_version + " | " + ret; 
		},
		streamer_status_color () {
			if(this.streamer_status == false) return "error";
			if(this.streamer_status) return "success";
			return "warning";
		},

 		update_status_color(update_status) {
      		if (this.update_status.status == 0) return "green";
      		return "red";
    	},
		update_status () {
      		var st = this.stats;
      		if (typeof(st) != "undefined" && st.instance != null && typeof(st.instance) != "undefined") {
        		if (typeof(st.instance.streamer_update_info) != "undefined") {
          			var info = st.instance.streamer_update_info;
          			return {
           				"time": datelib.format_date(info.timestamp) + " - " + datelib.format_time(info.timestamp),
            			"status": info.status || 0,
            			"message": info.message || []
          			}
        		}
      		}
      		return "";
    	},
		devices() {
			return _.get(this.stats, "system.devices");
		},
		stats () {
			var st = this.ws_channel.data;
			if (!_.isEmpty(st)) {
				return st;
			}
			return;
		},
		instance_stats() {
			return _.get(this.stats, "instance", {});
		},
		title () {
			return InstanceModel.title(this.instance);
		},
		channel_title_for_instance () {
			var ch = InstanceModel.channel(this.instance);
			return ChannelModel.title(ch);
		},
		rtmp_state() {
			if( !this.stats ) return
			if( !this.stats.instance ) return
			if( !this.stats.instance.rtmp_state ) return

			var urls = Object.keys(this.stats.instance.rtmp_state)
			return urls.map(url => {
				return {
					...this.stats.instance.rtmp_state[url].data,
					url,
					quality: this.stats.instance.rtmp_state[url].quality
				}
			})
		},

		srt_state() {
			if( !this.stats ) return
			if( !this.stats.instance ) return
			if( !this.stats.instance.srt_state ) return

			var urls = Object.keys(this.stats.instance.srt_state)
			return urls.map(url => {
				return {
					...this.stats.instance.srt_state[url].data,
					url,
					quality: this.stats.instance.srt_state[url].quality
				}
			})
		},

		srtla_state() {
			if( !this.stats ) return
			if( !this.stats.instance ) return
			if( !this.stats.instance.srtla_state ) return

			var urls = Object.keys(this.stats.instance.srtla_state)
			console.log(this.stats.instance.srtla_state);
			return urls.map(url => {
				return {
					data: this.stats.instance.srtla_state[url].data,
					url,
					quality: this.stats.instance.srtla_state[url].quality
				}
			})
		},



		input_routers_state() {
			if ( !this.stats ) return;
			if ( !this.stats.instance) return;
			if ( !this.stats.instance.input_routers) return;
			return this.stats.instance.input_routers;
		},
		output_state() {
			if ( !this.stats ) return;
			if ( !this.stats.instance) return;
			if ( !this.stats.instance.outputs) return;
			return this.stats.instance.outputs;
		},


		streamer_module_state() {
			if ( !this.stats) return;
			if ( !this.stats.instance) return;
			if ( !this.stats.instance.streamer_module) return;

			return this.stats.instance.streamer_module;
		},
		streamer_net_stats()  {
			if (!this.streamer_module_state) return;
			var ret = _.find(this.streamer_module_state, function(mod) {
				return mod.type == "network_monitor";
			});
			if (typeof(ret) != "undefined") {
				return ret.state;
			}
			return {};
		},
		encoders() {
			if (!this.streamer_module_state) return;
			return _.filter(this.streamer_module_state, function(mod) {
				return mod.type == "encoder";
			});
		},
		is_broadcaster_process_info() {
			return _.isObject(_.get(this.stats, "system.process_info"));
		},
		broadcaster_process_info() {
			return _.reduce(_.get(this.stats, "system.process_info", {}), (result, count, name) => {
				if(name != "total" && name != "rest" && name != "unknown") {
					result.push({name: name, count: count})
				}
				return result;
			}, []);
		},
		broadcaster_process() {
			return _.get(this.stats, "system.process_info", {});
		},
		broadcaster_process_list() {
			return this.broadcaster_process.list||[];
		}
		// sorted_rtmp_state() {
		// 	if(!this.rtmp_state) return

		// 	return [...this.rtmp_state].sort((a, b) => {
		// 		parseInt(a.quality.split('p')[0])
		// 		- parseInt(b.quality.split('p')[0])
		// 		- b.quality.split('p')[1] == 'aux' ? -1 : 0;
		// 	})
		// }
	}
}
</script>

<style lang="css" scoped>
	.quality-table {
		width: 100%;
		margin: 0 auto;
	}

	.quality-table__row {
		width: 100%;
		margin: 3px auto;
		border-radius: 15px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		cursor: default;
		/* background-color: rgba(0, 0, 0, 0.2) */
		padding: 1px 0 0 1px;
	}

	.quality-table__row--light {
		background-color: #eee;
	}

	.quality-table__row--dark {
		background-color: rgb(54, 54, 54);
	}

	.quality-table__value {
		padding-top: 5px;
		text-align: center;
	}

	.quality-table__header {
		width: 100%;
		margin: 3px auto;
		border-radius: 15px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.quality-table__header__value {
		text-align: center;
		font-size: 12px;
		cursor: pointer;
	}

	.v-chip--small {
		height: 18px !important;
		margin: 1.8px;
	}
</style>
